import React from "react";
import ImagePDF from "../../images/2023/12/FRGV-CEKANKONJOU-catalogue-de-jeux-en-bois.pdf.pdf";
function GrandJeuxPret(props) {
  return (
    <div>
      <h1>Prêts grands jeux</h1>
      <div>
        <p>Conditions</p>
        <p>
          Le prêt de jeu géants en bois est ouvert à tous à raison de 5 grand
          jeux maximum au tarif de 10 euros par jeu et par jours (plus adhésion
          si non souscrite pour l&#8217;année en cour).
        </p>

        <div>
          <a
            href={ImagePDF}
            class="wp-block-file__button wp-element-button"
            download
            aria-describedby="wp-block-file--media-a7d432d1-8806-48c5-ae05-1f8024e9795c"
          >
            Télécharger
          </a>
        </div>
      </div>
    </div>
  );
}

export default GrandJeuxPret;
